// Satirical content data for LinkedOut - a comedic LinkedIn parody

export const newsHeadlines = [
  {
    headline: "Man Who Says 'Let's Take This Offline' Has Never Taken Anything Offline",
    timeAgo: "3h ago",
    readers: "4,218 readers",
  },
  {
    headline: "Company Pivots to AI After CEO Discovers ChatGPT Can Write His Emails Too",
    timeAgo: "5h ago",
    readers: "12,847 readers",
  },
  {
    headline: "Entire Team Agrees Meeting Could Have Been an Email, Schedules Follow-Up Meeting to Discuss",
    timeAgo: "1h ago",
    readers: "8,631 readers",
  },
  {
    headline: "Startup Valued at $2B Despite Having Zero Revenue and a Ping Pong Table",
    timeAgo: "7h ago",
    readers: "15,204 readers",
  },
  {
    headline: "Man Who 'Doesn't Watch TV' Would Like to Tell You About His Morning Routine Again",
    timeAgo: "2h ago",
    readers: "6,912 readers",
  },
  {
    headline: "Report: 97% of 'Quick Syncs' Are Neither Quick Nor Synced",
    timeAgo: "4h ago",
    readers: "9,443 readers",
  },
  {
    headline: "Woman Adds 'Thought Leader' to Bio After Having One Thought",
    timeAgo: "6h ago",
    readers: "11,087 readers",
  },
  {
    headline: "Local CEO Reminds Everyone He Wakes Up at 4am, Forgets to Mention the Nap at 2pm",
    timeAgo: "8h ago",
    readers: "7,556 readers",
  },
];

export const networkSuggestions = [
  {
    name: "Brenda Synergise",
    headline: "Chief Vibes Officer at Disrupton Industries",
    photoUrl: "/images/user.svg",
    mutualConnections: 14,
  },
  {
    name: "Chad Bandwidth",
    headline: "Senior Vice President of Circling Back | Ex-Loop Closer",
    photoUrl: "/images/user.svg",
    mutualConnections: 7,
  },
  {
    name: "Karen Pipeline",
    headline: "Head of Unnecessary Meetings at MeetingCorp",
    photoUrl: "/images/user.svg",
    mutualConnections: 22,
  },
  {
    name: "Derek Leverage",
    headline: "Founder & CEO at Stealth Mode (We Can't Tell You What We Do)",
    photoUrl: "/images/user.svg",
    mutualConnections: 3,
  },
  {
    name: "Tiffany Blockchain",
    headline: "Evangelist of Things That Don't Need Evangelising",
    photoUrl: "/images/user.svg",
    mutualConnections: 19,
  },
  {
    name: "Gary Touchbase",
    headline: "Professional Devil's Advocate | Contrarian-at-Large",
    photoUrl: "/images/user.svg",
    mutualConnections: 11,
  },
  {
    name: "Melissa Agile",
    headline: "Scrum Mistress & Stand-Up Philosopher at SprintCo",
    photoUrl: "/images/user.svg",
    mutualConnections: 8,
  },
  {
    name: "Ron Stakeholder",
    headline: "I Turn Coffee into Jira Tickets | 10x Delegator",
    photoUrl: "/images/user.svg",
    mutualConnections: 5,
  },
  {
    name: "Patricia Pivot",
    headline: "Serial Entrepreneur (3 Failed Startups and Counting)",
    photoUrl: "/images/user.svg",
    mutualConnections: 16,
  },
  {
    name: "Steve Alignment",
    headline: "Director of Saying 'Great Question' Before Not Answering It",
    photoUrl: "/images/user.svg",
    mutualConnections: 9,
  },
  {
    name: "Janet OKR",
    headline: "VP of Making Simple Things Complicated at Frameworkify",
    photoUrl: "/images/user.svg",
    mutualConnections: 12,
  },
  {
    name: "Doug Ecosystem",
    headline: "Chief Disruption Officer | I Break Things That Work Fine",
    photoUrl: "/images/user.svg",
    mutualConnections: 4,
  },
];

export const jobListings = [
  {
    title: "Senior Vice President of Looking Busy",
    company: "Optics International",
    location: "Sydney, NSW (Hybrid - Must Be Seen at Desk Mon & Thu)",
    timePosted: "2 hours ago",
    tags: ["Full-time", "Senior", "Performative"],
    logoColor: "#0a66c2",
  },
  {
    title: "Head of Unnecessary Meetings",
    company: "CalendarMax Corp",
    location: "Melbourne, VIC (Remote But Must Be on Camera)",
    timePosted: "5 hours ago",
    tags: ["Full-time", "Leadership", "No Actual Output Required"],
    logoColor: "#057642",
  },
  {
    title: "Junior Thought Leader",
    company: "ThinkFluence Agency",
    location: "Brisbane, QLD",
    timePosted: "1 day ago",
    tags: ["Entry Level", "Requires 8 Years Experience"],
    logoColor: "#b24020",
  },
  {
    title: "Chief Synergy Architect",
    company: "BuzzWord Solutions Pty Ltd",
    location: "Perth, WA (Fully Remote From Our Open Plan Office)",
    timePosted: "3 hours ago",
    tags: ["Full-time", "C-Suite Adjacent", "Vague"],
    logoColor: "#7c3aed",
  },
  {
    title: "Disruption Intern (Unpaid But Lots of Exposure)",
    company: "Move Fast Break Things Inc",
    location: "Adelaide, SA",
    timePosted: "12 hours ago",
    tags: ["Internship", "Exposure-Based Compensation"],
    logoColor: "#e16b16",
  },
  {
    title: "Full Stack Excuse Engineer",
    company: "Deadline Dodge Consulting",
    location: "Canberra, ACT",
    timePosted: "4 hours ago",
    tags: ["Contract", "Blame-Tolerant", "Firefighter Mindset"],
    logoColor: "#0a66c2",
  },
  {
    title: "Director of Telling People to Check Slack",
    company: "Notification Overload Ltd",
    location: "Gold Coast, QLD (Async But Also Always On)",
    timePosted: "8 hours ago",
    tags: ["Full-time", "Mid-Senior", "Ping Management"],
    logoColor: "#057642",
  },
  {
    title: "Wellness & Burnout Paradox Manager",
    company: "Grind Culture Wellness Co",
    location: "Remote (Must Respond Within 5 Min at All Times)",
    timePosted: "6 hours ago",
    tags: ["Full-time", "Self-Care Required But Not Scheduled"],
    logoColor: "#b24020",
  },
];

export const jobCollections = [
  "Remote",
  "Work From Couch",
  "Thought Leadership",
  "Synergy Roles",
  "Hustle Culture",
  "Quiet Quitting",
];

export const messages = [
  {
    name: "Brenda Synergise",
    headline: "Chief Vibes Officer at Disrupton Industries",
    photoUrl: "/images/user.svg",
    lastMessage: "Let's circle back on the circle back we circled back on",
    time: "2:34 PM",
    unread: true,
  },
  {
    name: "Chad Bandwidth",
    headline: "Senior Vice President of Circling Back | Ex-Loop Closer",
    photoUrl: "/images/user.svg",
    lastMessage: "Quick question (it is not quick)",
    time: "11:15 AM",
    unread: true,
  },
  {
    name: "Gary Touchbase",
    headline: "Professional Devil's Advocate | Contrarian-at-Large",
    photoUrl: "/images/user.svg",
    lastMessage: "Just wanted to put this on your radar and also your other radar",
    time: "Yesterday",
    unread: false,
  },
  {
    name: "Patricia Pivot",
    headline: "Serial Entrepreneur (3 Failed Startups and Counting)",
    photoUrl: "/images/user.svg",
    lastMessage: "Have you considered a pivot? We should pivot.",
    time: "Yesterday",
    unread: false,
  },
  {
    name: "Derek Leverage",
    headline: "Founder & CEO at Stealth Mode (We Can't Tell You What We Do)",
    photoUrl: "/images/user.svg",
    lastMessage: "Sent you an NDA for looking at this message",
    time: "Mon",
    unread: false,
  },
  {
    name: "Janet OKR",
    headline: "VP of Making Simple Things Complicated at Frameworkify",
    photoUrl: "/images/user.svg",
    lastMessage: "Can you OKR me on the KPIs for the Q3 ROI ASAP?",
    time: "Mon",
    unread: true,
  },
];

export const conversationMessages = [
  {
    sender: "Brenda Synergise",
    text: "Hi! I have an incredible business opportunity I wanted to run by you.",
    time: "2:30 PM",
    isMe: false,
  },
  {
    sender: "Me",
    text: "Sure, what's the opportunity?",
    time: "2:31 PM",
    isMe: true,
  },
  {
    sender: "Brenda Synergise",
    text: "So imagine Uber, but for people who want to be told they're doing a great job. We call it Uber-Affirmation.",
    time: "2:32 PM",
    isMe: false,
  },
  {
    sender: "Me",
    text: "That's... just therapy?",
    time: "2:32 PM",
    isMe: true,
  },
  {
    sender: "Brenda Synergise",
    text: "No no no. Therapy is a legacy model. This is DISRUPTION. A stranger drives to your house and tells you your PowerPoint was incredible.",
    time: "2:33 PM",
    isMe: false,
  },
  {
    sender: "Me",
    text: "I genuinely can't tell if you're serious.",
    time: "2:33 PM",
    isMe: true,
  },
  {
    sender: "Brenda Synergise",
    text: "We've already got $4M in seed funding. The driver also rates your handshake out of 10. Premium tier includes eye contact.",
    time: "2:34 PM",
    isMe: false,
  },
  {
    sender: "Me",
    text: "I'm going to need to take this offline and never bring it back online.",
    time: "2:34 PM",
    isMe: true,
  },
];

export const notifications = [
  {
    type: "like",
    text: "Chad Bandwidth and 47 others liked your post about how waking up at 3am changed your life",
    time: "2h ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
  {
    type: "comment",
    text: "Brenda Synergise commented on your post: \"This is exactly what I was saying in my TEDx talk that got cancelled\"",
    time: "3h ago",
    photoUrl: "/images/user.svg",
    hasPreview: true,
    previewTitle: "Your post about synergy",
  },
  {
    type: "connection",
    text: "Gary Touchbase wants to connect - You both attended the same conference but made no eye contact",
    time: "5h ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
  {
    type: "mention",
    text: "Derek Leverage mentioned you in a post: \"Shoutout to my incredible network for validating my existence\"",
    time: "6h ago",
    photoUrl: "/images/user.svg",
    hasPreview: true,
    previewTitle: "A post about gratitude and personal branding",
  },
  {
    type: "job",
    text: "A job you might be interested in: Chief Overthinking Officer at Anxiety & Associates",
    time: "8h ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
  {
    type: "like",
    text: "Patricia Pivot liked your comment: \"Agree - failure is just success that hasn't pivoted yet\"",
    time: "10h ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
  {
    type: "comment",
    text: "Ron Stakeholder replied to your comment: \"Let's unpack this in a 90-minute brainstorm with 14 people\"",
    time: "12h ago",
    photoUrl: "/images/user.svg",
    hasPreview: true,
    previewTitle: "Discussion about Q3 alignment",
  },
  {
    type: "connection",
    text: "Melissa Agile accepted your connection request - She also added you to 3 Slack channels you'll never read",
    time: "1d ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
  {
    type: "mention",
    text: "Janet OKR tagged you in a document: \"Q4 Roadmap to Discussing the Q3 Roadmap We Never Finished\"",
    time: "1d ago",
    photoUrl: "/images/user.svg",
    hasPreview: true,
    previewTitle: "Q4 Strategic Alignment Sync Pre-Read",
  },
  {
    type: "job",
    text: "Based on your profile: Senior Manager of Managing Managers Who Manage at ManageCorp",
    time: "2d ago",
    photoUrl: "/images/user.svg",
    hasPreview: false,
    previewTitle: "",
  },
];

export const profileData = {
  about:
    "Results-driven synergy evangelist with 10+ years of experience in leveraging cross-functional paradigms to deliver best-in-class outcomes nobody asked for. Passionate about disrupting industries that are working perfectly fine. My superpower? Turning a 2-sentence email into a 45-minute stand-up. I don't just think outside the box - I've eliminated the box entirely and replaced it with an agile framework. Looking to connect with fellow thought leaders, hustle enthusiasts, and anyone who unironically uses the phrase 'move the needle'. Let's grab a virtual coffee and not follow up.",
  experience: [
    {
      title: "Head of Strategic Buzzword Deployment",
      company: "SynergiCo Global Solutions",
      duration: "Jan 2021 - Present",
      description:
        "Spearheading a cross-functional initiative to leverage AI-driven synergies across all verticals. Successfully increased the number of buzzwords per meeting by 340%. Key achievement: Convinced the board that 'blockchain' was relevant to our catering business.",
      logoColor: "#0a66c2",
    },
    {
      title: "Director of Pretending to Understand Crypto",
      company: "Web3 Vibes Ltd",
      duration: "Mar 2019 - Dec 2020",
      description:
        "Led a team of 12 in nodding confidently during blockchain presentations. Pioneered the company's pivot from actual revenue to 'community building'. Successfully launched an NFT collection of corporate headshots that sold zero units.",
      logoColor: "#057642",
    },
    {
      title: "Junior Disruption Associate",
      company: "Break Things First Inc",
      duration: "Jun 2016 - Feb 2019",
      description:
        "Disrupted the office coffee machine within the first week. Graduated to disrupting client relationships by Q2. Received the 'Most Likely to Use the Word Pivot' award three years running.",
      logoColor: "#b24020",
    },
  ],
  education: [
    {
      school: "University of Hustle Culture",
      degree: "MBA in Thought Leadership & Personal Branding",
      years: "2014 - 2016",
      logoColor: "#7c3aed",
    },
    {
      school: "LinkedIn Learning (Completed 3 of 847 Saved Courses)",
      degree: "Certificate in Starting Things and Not Finishing Them",
      years: "2016 - Present",
      logoColor: "#e16b16",
    },
  ],
  skills: [
    "Aggressive Networking",
    "Buzzword Fluency (Native Speaker)",
    "Turning Meetings Into Longer Meetings",
    "Strategic Procrastination",
    "Emotional Intelligence (Self-Assessed)",
    "Replying-All When Not Necessary",
  ],
};
